module.exports = __webpack_public_path__ + "static/img/show_pic5.c1bd4af8.png";